var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.3594H35V34.4531H0V33.3594Z",
    fill: "#007E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28125 33.9062H2.1875V18.5938H8.20312V19.6875H3.28125V33.9062Z",
    fill: "#007E85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 33.9062H31.7188V19.6875H26.7969V18.5938H32.8125V33.9062Z",
    fill: "#007E85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3438 33.9062H26.25V7.10938H21.3281V6.01562H27.3438V33.9062Z",
    fill: "#007E85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 33.9062H7.65625V6.01562H13.6719V7.10938H8.75V33.9062Z",
    fill: "#007E85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 4.375H18.0469V8.75H16.9531V4.375Z",
    fill: "#007E85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 6.01562H19.6875V7.10938H15.3125V6.01562Z",
    fill: "#007E85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 10.9375H13.125V2.1875H21.875V10.9375ZM14.2188 9.84375H20.7812V3.28125H14.2188V9.84375Z",
    fill: "#007E85"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 33.9062H20.7812V28.4375H14.2188V33.9062H13.125V27.3438H21.875V33.9062Z",
    fill: "#007E85"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 24.6094H12.0312V20.2344H16.4062V24.6094ZM13.125 23.5156H15.3125V21.3281H13.125V23.5156Z",
    fill: "#007E85"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 24.6094H18.5938V20.2344H22.9688V24.6094ZM19.6875 23.5156H21.875V21.3281H19.6875V23.5156Z",
    fill: "#007E85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 18.0469H12.0312V13.6719H16.4062V18.0469ZM13.125 16.9531H15.3125V14.7656H13.125V16.9531Z",
    fill: "#007E85"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 18.0469H18.5938V13.6719H22.9688V18.0469ZM19.6875 16.9531H21.875V14.7656H19.6875V16.9531Z",
    fill: "#007E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.f112bac4cb9234216decce719224bcd1.svg";
export { ForwardRef as ReactComponent };